// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"307":"9a9251ea","407":"f02db33e","453":"97397a38","465":"19ed6996","623":"5e442070","869":"d6453f1c","997":"ddac531f"}[chunkId] + ".chunk.js";
};